export default {"src":"/_next/static/media/google-icon.27dab45d.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};